<template>
  <div>
    <span @click="handleClick">
      <el-input
        v-model="goodsIds"
        @click="handleClick"
        placeholder="多个ID以逗号分隔"
        readonly
      ></el-input> </span
    ><!-- 选择商品组件 -->
    <select-goods
      v-if="goodsVisible"
      :isShow="goodsVisible"
      :skuSearch="isNeedSku"
      @close="handleClose"
      :selectGoods="postForm"
      :selectGoodsSkuList="postForm"
      :moduleType="true"
    ></select-goods>
  </div>
</template>

<script>
import selectGoods from "@/components/selectGoodsMonitor.vue";
export default {
  name: "",
  components: {
    selectGoods,
  },
  model: {
    prop: "goodsIds",
    event: "update",
  },
  props: {
    goodsIds: {
      type: String,
    },
    isNeedSku: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      postForm: [], // 选择的商品列表
      goodsVisible: false,
      isSku: false,
    };
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    handleClick() {
      this.goodsVisible = true;
    },
    handleClose(val) {
      console.log(val,211);
      if(val){
        this.postForm = val
        let newArr = [];
        this.postForm.forEach((item) => {
            newArr.push(item.skuId);
          });
       this.$emit("update", newArr.join(","));
      }
      this.goodsVisible = false;
    },
  },
};
</script>
<style lang="scss" scoped></style>
